import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => {
  const styles: StyleRules = {
    container: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: '1.75rem',
      margin: '1.5rem 0',
    },

    sunLogo: {
      width: '5rem',
      height: '2.813rem',
    },

    helperText: {
      margin: '0',
      marginTop: '1.25rem',
      fontWeight: 'bold',
      color: '#37474F',
    },

    cardContainer: {
      backgroundColor: '#fff',
      maxWidth: '50%',
      border: '1px solid #ECEFF1',
      borderRadius: '1rem',
      padding: '1.25rem',
    },

    cardHeader: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: '0.75rem',
    },

    cardTitle: {
      fontWeight: 'bold',
      fontSize: '1.25rem',
    },

    informative: {
      margin: '1.25rem 0',
      marginLeft: '0.5rem',
    },

    button: {
      backgroundColor: '#fff',
      color: '#265AAB',
      textTransform: 'initial',
      fontWeight: 'bold',
    },
  };
  return styles;
});
